import { Component, Element } from '@stencil/core';

@Component({
  shadow: false,
  styleUrl: 'igws-hr.less',
  tag: 'igws-hr',
})
export class HorizontalRuleComponent {
  targetWidth: number = 200;
  observer!: IntersectionObserver;

  @Element() el!: HTMLIgwsHrElement;

  componentWillLoad() {
    if (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in IntersectionObserverEntry.prototype
    ) {
      if (this.el.classList.contains('separator') || this.el.classList.contains('separator-thin')) {
        this.el.classList.add('separator--animated');
      }
    }
  }

  componentDidLoad() {
    if (this.el.classList.contains('separator--animated')) {
      const offset = window.innerHeight / 12;
      const observerOptions = {
        root: null,
        rootMargin: `0px 0px -${offset}px 0px`,
        threshold: [0.01],
      };

      this.observer = new IntersectionObserver(this.onIntersection, observerOptions);

      this.observer.observe(this.el);
    }
  }

  onIntersection = (entries: any) => {
    entries.forEach((entry: any) => {
      if (entry.intersectionRatio > 0) {
        entry.target.style.setProperty('--hr-width-animated', 'var(--hr-width)');
      }

      if (entry.intersectionRatio === 1) {
        this.observer.unobserve(entry.target);
      }
    });
  };
}
